import dayjs from "dayjs"; // Install via npm if not already: npm install dayjs

export const getDateRange = (period) => {
  const endDate = dayjs().add(1, 'day').endOf('day').format('YYYY-MM-DD');
  let startDate;
  switch (period) {
    case "Last week":
      startDate = dayjs().subtract(7, "day").format("YYYY-MM-DD");
      break;
    case "Last month":
      startDate = dayjs().subtract(1, "month").format("YYYY-MM-DD");
      break;
    case "Last quarter":
      startDate = dayjs().subtract(3, "month").format("YYYY-MM-DD");
      break;
    case "Last year":
      startDate = dayjs().subtract(1, "year").format("YYYY-MM-DD");
      break;
    default:
      startDate = dayjs().subtract(1, "month").format("YYYY-MM-DD");
  }

  return { startDate, endDate };
};
